module.exports = __webpack_public_path__ + "static/media/weekly-products.f9f058ee.png";